import { jsx as _jsx } from "react/jsx-runtime";
import { Modal as BsModal } from 'react-bootstrap';
export const Body = ({ message }) => {
    if (!message)
        return null;
    return _jsx(BsModal.Body, { children: message });
};
